import React from 'react';
import { instructorResourceDefinition } from '../resources/instructorResourceDefinition';
import connect from './connect';
import { createLink } from '../actions/material';
import { createLoader } from '../loader';
import PropTypes from 'prop-types';
import { setContent } from 'actions/manage_content';

import LinkDisplay from './link_dialog/display.jsx';

class LinkDialog extends React.Component {
    static displayName = 'LinkDialog';

    static propTypes = {
        selectedSections: PropTypes.array,
        title: PropTypes.string,
        url: PropTypes.string,
        embed: PropTypes.string,
        description: PropTypes.string,
        setContent: PropTypes.func,
        terms: PropTypes.array,
        sections: PropTypes.array,
        createLink: PropTypes.func.isRequired,
        onClose: PropTypes.func,
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            validationErrors: {},
        };
    }

    onSave = fileElement => {
        const {
            onClose,
            createLink,
            title,
            url,
            selectedSections,
            description,
            embed,
        } = this.props;
        if (this.validate()) {
            onClose();
            createLink({
                title,
                url,
                sections: selectedSections,
                description,
                embed,
            });
        }
    };

    validate = () => {
        const validationErrors = {};

        if (!this.props.title.trim()) {
            validationErrors.title = 'Include a title for this resource.';
        }

        if (!this.props.url.trim()) {
            validationErrors.url = 'Include a url for this resource.';
        }

        if (this.props.selectedSections.length === 0) {
            validationErrors.sections =
                'Required: Assign this resource to one or more areas.';
        }

        this.setState({ validationErrors });
        return Object.keys(validationErrors).length === 0;
    };

    render() {
        const {
            selectedSections,
            title,
            url,
            embed,
            description,
            setContent,
        } = this.props;
        return (
            <LinkDisplay
                validationErrors={this.state.validationErrors}
                selectedSections={selectedSections}
                title={title}
                url={url}
                embed={embed}
                description={description}
                setContent={setContent}
                onSave={this.onSave}
                onClose={this.props.onClose}
                sections={this.props.sections}
                terms={this.props.terms}
            />
        );
    }
}

export default connect(
    state => ({ rootState: state, ...state.manage_content }),
    { createLink, setContent },
    null,
    {
        pure: true,
    }
)(
    createLoader({
        component: LinkDialog,
        resources: instructorResourceDefinition(),
    })
);



// WEBPACK FOOTER //
// ./src/components/link_dialog.jsx